// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorScreenContent_Re0XR {
  display : flex;
  flex-direction : row;
  height : 100%;
  align-items : center;
  justify-content: center;
}

.errorScreenImage_F9YVR {
  width : 276.45px; 
  height : 200.5px;
}

.errorScreenTextColumn_fHMiA {
  width : 323.55px;
  padding-left : 16px;
}

.errorScreenTitle_GLymg {
  font-size : 20px;
  font-weight : 700;
}

.errorScreenMessage_X87YF {
  font-size : 15px; 
  line-height : 24px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/integrations/Classes.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".errorScreenContent {\n  display : flex;\n  flex-direction : row;\n  height : 100%;\n  align-items : center;\n  justify-content: center;\n}\n\n.errorScreenImage {\n  width : 276.45px; \n  height : 200.5px;\n}\n\n.errorScreenTextColumn {\n  width : 323.55px;\n  padding-left : 16px;\n}\n\n.errorScreenTitle {\n  font-size : 20px;\n  font-weight : 700;\n}\n\n.errorScreenMessage {\n  font-size : 15px; \n  line-height : 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorScreenContent": `errorScreenContent_Re0XR`,
	"errorScreenImage": `errorScreenImage_F9YVR`,
	"errorScreenTextColumn": `errorScreenTextColumn_fHMiA`,
	"errorScreenTitle": `errorScreenTitle_GLymg`,
	"errorScreenMessage": `errorScreenMessage_X87YF`
};
export default ___CSS_LOADER_EXPORT___;
